"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject());

function template() {
  var closeBtn = null,
      containerStyle = {};
  var _this$state = this.state,
      offsetTop = _this$state.offsetTop,
      offsetLeft = _this$state.offsetLeft,
      visible = _this$state.visible,
      minWidth = _this$state.minWidth,
      _this$props = this.props,
      closeAvailable = _this$props.closeAvailable,
      appearance = _this$props.theme.appearance,
      className = _this$props.className,
      children = _this$props.children,
      onClose = _this$props.onClose,
      minOffsetTop = _this$props.minOffsetTop,
      minOffsetBottom = _this$props.minOffsetBottom,
      styles = this.compileStyled(_index["default"]),
      CloseIcon = appearance;

  if (closeAvailable) {
    closeBtn = _react["default"].createElement(Div, {
      styles: styles.closeIcon
    }, _react["default"].createElement(_IconButton["default"], {
      onClick: onClose
    }, _react["default"].createElement(CloseIcon, null)));
  }

  if (offsetTop !== null && offsetLeft !== null) {
    containerStyle = {
      transform: "translateY(".concat(offsetTop, ") translateX(").concat(offsetLeft, ")")
    };
  }

  if (visible) {
    containerStyle.opacity = 1;
  }

  return _react["default"].createElement(Div, {
    className: className,
    styles: styles.root,
    style: {
      minWidth: minWidth
    },
    ref: this.root
  }, _react["default"].createElement(Div, {
    styles: styles.overlay,
    onClick: closeAvailable ? onClose : null
  }), _react["default"].createElement(Div, {
    styles: _objectSpread({}, styles.wrapper, {
      paddingTop: minOffsetTop + 'px',
      paddingBottom: minOffsetBottom + 'px'
    }, containerStyle),
    ref: this.container
  }, _react["default"].createElement(Div, {
    styles: styles.container
  }, _react["default"].createElement("div", null, children), closeBtn)));
}